import classnames from 'classnames'
import React from 'react'

import { OptionContainer } from '../option-container/option-container'
import { OptionProp } from '../OptionSelector.constant'

import styles from './colorOption.module.scss'

type ColorOptionProps = {
  value: string
  displayName?: string
  hexCode?: string
  disabled?: boolean
  onChange?: (value: string) => void
  showRedDot?: boolean
} & Pick<OptionProp, 'isSelected' | 'addborder' | 'selectionSetId' | 'className'>
export const ColorOption = ({
  value,
  displayName,
  hexCode,
  isSelected,
  addborder,
  disabled,
  selectionSetId,
  className,
  onChange,
  showRedDot,
}: ColorOptionProps) => {
  const borderClass = styles.colorDotBorder
  return (
    <div className={classnames(styles.colorOptionWrapper)}>
      <OptionContainer
        value={value}
        displayName={displayName}
        isSelected={isSelected}
        selectionSetId={selectionSetId}
        srOnly
        labelClassName={classnames(styles.label, className)}
        inputClassName={styles.input}
        disabled={disabled}
        onChange={onChange}
      >
        <span
          className={classnames(styles.colorDot, {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            [borderClass!]: addborder,
            [`${styles.isSelected}`]: isSelected,
          })}
          style={{ backgroundColor: hexCode }}
        />
      </OptionContainer>
      {showRedDot && <div className={classnames(styles.redDot)} />}
    </div>
  )
}

const ColorOptionWithOptionValue = ({ optionValue, ...props }: OptionProp) => {
  return (
    <ColorOption
      value={optionValue.value}
      displayName={optionValue.displayName}
      hexCode={optionValue.hexCode}
      {...props}
    />
  )
}

export default ColorOptionWithOptionValue
